import React from 'react';
import { message as antMessage } from 'antd';
import { playSuccessSound, playErrorSound, playWarningSound } from './soundUtils';

// Create a wrapper that mimics the Ant Design message API
const audioMessage = {
  success: (content, duration, onClose) => {
    playSuccessSound();
    return antMessage.success(content, duration, onClose);
  },
  error: (content, duration, onClose) => {
    playErrorSound();
    return antMessage.error(content, duration, onClose);
  },
  warning: (content, duration, onClose) => {
    playWarningSound();
    return antMessage.warning(content, duration, onClose);
  },
  info: (content, duration, onClose) => {
    return antMessage.info(content, duration, onClose);
  },
  loading: (content, duration, onClose) => {
    return antMessage.loading(content, duration, onClose);
  },
  open: (config) => {
    if (config.type === 'success') playSuccessSound();
    else if (config.type === 'error') playErrorSound();
    else if (config.type === 'warning') playWarningSound();
    return antMessage.open(config);
  },
  destroy: () => {
    return antMessage.destroy();
  }
};

// For backwards compatibility, export individual methods
export const messageSuccess = (content, duration, onClose) => {
  playSuccessSound();
  return antMessage.success(content, duration, onClose);
};

export const messageError = (content, duration, onClose) => {
  playErrorSound();
  return antMessage.error(content, duration, onClose);
};

export const messageWarning = (content, duration, onClose) => {
  playWarningSound();
  return antMessage.warning(content, duration, onClose);
};

export const messageInfo = (content, duration, onClose) => {
  return antMessage.info(content, duration, onClose);
};

export { audioMessage }; 